module.exports = __webpack_public_path__ + "img/engraving@2x.28bdfa2.jpg";